export class ActiveOrder {
	closingHour: number;
	closingTime: number;
	deliveryAddress: string;
	deliveryAddressName: string;
	deliveryCity: string;
	deliveryOption: number;
	deliveryDate: number;
	shipmentDate: number;
	shipToCode: string;
	volume: number;
	addProductsAllowed: boolean;
	// Used to add an extra option to the select and differ from the 'real' items.
	public dummyValue: string;

	get id(): string {
		return ActiveOrder.getId(this.shipmentDate, this.shipToCode);
	}

	public static getId(shipmentDate: number, shipToCode: string): string {
		return shipmentDate.toString() + '-' + shipToCode.toString();
	}
}
